import { render, staticRenderFns } from "./BusinessInformationConversationList.vue?vue&type=template&id=5a70a7d6&scoped=true"
import script from "./BusinessInformationConversationList.vue?vue&type=script&lang=js"
export * from "./BusinessInformationConversationList.vue?vue&type=script&lang=js"
import style0 from "./BusinessInformationConversationList.vue?vue&type=style&index=0&id=5a70a7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70a7d6",
  null
  
)

export default component.exports